import {
  Box,
  Button,
  FormControlLabel,
  MuiRadioGroup,
  Radio,
  TextField,
  Typography,
} from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

import useAttributionSurvey from "../../hooks/useAttributionSurvey";

export default function HowDidYouHearAboutUsModal({
  handleFlowComplete,
}: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\enrolling\\HowDidYouHearAboutUsModal",
  );

  const {
    selectedOption,
    handleChange,
    additionalDetails,
    handleAdditionalDetailsChange,
    orderedOptions,
    handleSkipOption,
    handleSurveyCompletion,
  } = useAttributionSurvey({ onComplete: handleFlowComplete });

  return (
    <>
      <Box
        sx={{
          justifyContent: "left",
        }}
      >
        <Typography
          variant="h5"
          sx={{ margin: "10px auto", fontWeight: "bold" }}
        >
          {t("Where did you hear about Outschool?")}
        </Typography>
        {/* Use MuiRadioGroup directly to allow us to inject the textfield under certain options */}
        <MuiRadioGroup value={selectedOption} onChange={handleChange}>
          {orderedOptions?.map(
            ({
              label,
              value,
              shouldGetAdditionalDetails,
              additionalDetailsPlaceholder,
            }) => {
              return (
                <React.Fragment key={value}>
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={label}
                    sx={{ marginBottom: "unset" }}
                  />
                  {selectedOption === value && shouldGetAdditionalDetails && (
                    <Box
                      flex
                      sx={{ flexDirection: "column", marginLeft: "31px" }}
                    >
                      <Box>
                        <TextField
                          value={additionalDetails}
                          onChange={handleAdditionalDetailsChange}
                          placeholder={additionalDetailsPlaceholder}
                          size="small"
                        />
                      </Box>
                    </Box>
                  )}
                </React.Fragment>
              );
            },
          )}
        </MuiRadioGroup>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "1em",
          }}
        >
          <Button
            variant="contained"
            disabled={selectedOption === ""}
            onClick={handleSurveyCompletion}
          >
            {t("Submit")}
          </Button>
          <Button onClick={handleSkipOption}>{t("Skip")}</Button>
        </Box>
      </Box>
    </>
  );
}
